import { render, staticRenderFns } from "./DepartamentoParaguai.vue?vue&type=template&id=4f902ca9&lang=pug"
import script from "./DepartamentoParaguai.vue?vue&type=script&lang=js"
export * from "./DepartamentoParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports